import React, { useState } from "react";
import classes from "./AddDeviceModal.css";
import Box from "../../hoc/Box/Box";
import DeviceIcon from '../../components/UI/DeviceIcon/DeviceIcon';
import { getDeviceIconUrl, getDeviceName } from "../../shared/common";


const AddDeviceModal = ({ hideModal, devices, advancedDeviceIds, selectedDeviceSubnet, onAddIpReservation, realDhcp }) => {
  const [state, setState] = useState({
    deviceMac: "",
    macAddressError: false,
    duplicateMacError: false
  });
  const [isNewFormOpened, setIsNewFormOpened] = useState(false);

  const handleInputChange = (event) => {
    const { value, name } = event.target;
    setState((copyState) => {
      const newState = { ...copyState, [name]: value };
      if (name === 'deviceMac') {
        // #1 check duplicate mac against realDhcp and devices list
        const macLower = value.trim().toLowerCase();
        const inDhcp = realDhcp?.some(el => el.mac?.toLowerCase() === macLower);
        const inDevices = devices?.some(el => el.mac?.toLowerCase() === macLower);
        newState.duplicateMacError = macLower.length > 0 && (inDhcp || inDevices);
      }
      return newState;
    });
  };

  const validateInput = (value) => {
    const regex = new RegExp('^([a-zA-Z0-9]{2}:)*([a-zA-Z0-9]{2})$');
    return regex.test(value) && value.length <= 17;
  }

  const getDisplayName = (device) => getDeviceName(device, advancedDeviceIds).deviceName || '';

  const otherDevices = devices?.filter(element => !realDhcp?.find((el) => el.mac === element.mac));

  // #1 duplicate check for device-list select button
  const isMacDuplicate = (mac) => {
    const macLower = mac?.toLowerCase();
    return realDhcp?.some(el => el.mac?.toLowerCase() === macLower);
  };

  return (
    <Box>
      <div className={classes.section}>
        <div
          className={classes.sectionHeader}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <strong>{isNewFormOpened ? 'Add New Device' : 'Device List'}</strong>
          {/* hide top Add New button only when form is open */}
          {!isNewFormOpened && <button onClick={() => setIsNewFormOpened(true)} className={classes.addnewdeviceLink}>Add New</button>}
        </div>

       {isNewFormOpened ?
       <div>
            <Box>
            <div id='configureSecondSSIDPasswordText' style={{ color: "#000", fontSize: "small" }}>
              Device MAC
            </div>
            <div className={classes.Input} style={{ padding: "2px 20px 20px 0px" }}>
              <input
                className={classes.InputElement}
                name='deviceMac'
                placeholder='Enter Device MAC'
                onChange={handleInputChange}
                />
                {state.macAddressError && <div style={{ color: 'red'}}>Invalid device mac</div>}
                {state.duplicateMacError && <div style={{ color: 'red'}}>This device MAC already exists in the reservations list</div>}
            </div>
          </Box>
          <Box>
            <div className={classes.BodyRow}>
              <div style={{ display: "flex" }}>
                  <div>
                  <button
                    id='ConfigureSSIDSaveButton'
                    className={classes.SaveButton}
                    onClick={() => {
                      onAddIpReservation(
                         selectedDeviceSubnet,
                         state.deviceMac,
                        '',
                        false,
                        () => {
                          setIsNewFormOpened(false)
                          hideModal(false, true)
                        },
                        'staticIp'
                       );
                    }}
                    btnType='Success'
                    disabled={!state.deviceMac?.trim() || state.macAddressError || state.duplicateMacError}
                  >
                    Save
                  </button>
                  <button
                    id='ConfigureSSIDCancelButton'
                    className={classes.CancelButton}
                    onClick={() => setIsNewFormOpened(false)}
                  >
                    {"Cancel"}
                  </button>
                </div>
              </div>
            </div>
          </Box>
        </div>:
        <div>
          <div className={classes.modalbody} >
          {!devices?.length && <div className={classes.noDevices}>
              <span>No devices connected to the Network.</span>
              <button onClick={() => setIsNewFormOpened(true)} className={classes.addnewdeviceLink}>Add New Device</button>
              </div>}
          {devices?.length > 0 && otherDevices?.length === 0 && <div className={classes.noDevices}>
              <span>No known devices found.</span>
              <button onClick={() => setIsNewFormOpened(true)} className={classes.addnewdeviceLink}>Add New Device</button>
              </div>}
              {otherDevices?.map((device) => {
                // #3 fallback to hostname
                const displayName = getDisplayName(device);
                const duplicate = isMacDuplicate(device.mac);
                return (
                <div className={classes.devicelist}
                  style={{ display:'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ display:'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
                    <DeviceIcon size={30} iconUrl={getDeviceIconUrl(device.mac, advancedDeviceIds)} />
                    <span
                      id="deviceName"
                      style={{
                        padding: '6px 6px 6px 7px',
                        cursor: 'pointer',
                        lineHeight: '1.5em',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                      }}
                      className={classes.RegularButton}
                    >
                      {displayName}
                    </span>
                  </div>
                  {/* #5 fixed width select button */}
                  <button
                    className={classes.SelectButton}
                    disabled={duplicate}
                    title={duplicate ? 'Already in reservations' : ''}
                    onClick={() => {
                      onAddIpReservation(
                        selectedDeviceSubnet,
                        device.mac,
                        (getDeviceName(device, advancedDeviceIds).deviceName || '').split(/\s/).join(''),
                        true,
                        () => { hideModal(false, true); },
                        'staticIp'
                      );
                    }}
                  >select</button>
                </div>
              )})}
          </div>
          <button
            id='ConfigureSSIDCancelButton'
            className={classes.CancelButton}
            onClick={() => { hideModal(false); }}
          >
            {"Cancel"}
          </button>
        </div>}
      </div>
    </Box>
  );
};

export default AddDeviceModal;
